// Plain text manager (no encryption)
export class EncryptionManager {
  constructor() {
    // No encryption setup needed
  }

  async encrypt(plaintext) {
    return plaintext;
  }

  async safeDecrypt(input) {
    return input;
  }

  async decrypt(input) {
    return input;
  }
}